"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsOperationColumn = void 0;
exports.AnalyticsOperationColumn = {
    Id: "id",
    Cost: "cost",
    CostBreakdownLlm: "costBreakdown.llm",
    CostBreakdownStt: "costBreakdown.stt",
    CostBreakdownTts: "costBreakdown.tts",
    CostBreakdownVapi: "costBreakdown.vapi",
    CostBreakdownTtsCharacters: "costBreakdown.ttsCharacters",
    CostBreakdownLlmPromptTokens: "costBreakdown.llmPromptTokens",
    CostBreakdownLlmCompletionTokens: "costBreakdown.llmCompletionTokens",
    Duration: "duration",
};
